var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7121_45735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2C1.26666 2 0.666664 2.6 0.666664 3.33333V11.3333C0.666664 12.0667 1.26666 12.6667 2 12.6667H5.33333V13.3333C5.33333 13.7 5.63333 14 6 14H10C10.3667 14 10.6667 13.7 10.6667 13.3333V12.6667H14C14.7333 12.6667 15.3333 12.0667 15.3333 11.3333V3.33333C15.3333 2.6 14.7333 2 14 2ZM13.3333 11.3333H2.66666C2.3 11.3333 2 11.0333 2 10.6667V4C2 3.63333 2.3 3.33333 2.66666 3.33333H13.3333C13.7 3.33333 14 3.63333 14 4V10.6667C14 11.0333 13.7 11.3333 13.3333 11.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.33334,
    y: 4.66667,
    width: 6.66667,
    height: 5.33333,
    rx: 1,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7121_45735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/Screen.a436c29c3c35b38f12820c36ee4d0c7c.svg";
export { ForwardRef as ReactComponent };